<template>
  <event-management
    class="event-management__extended"
    :get-applications="getApplications"
    :get-categories="getCategories"
    :get-event="getEvent"
    :get-roles="getRoles"
    :save-event="saveEvent"
    :update-event="updateEvent"
  />
</template>

<script>
import { EventManagement } from 'operations';
import service from '@/services/common/dashboard.api.js';
import { getApplications as _getApplications } from '@/services/common/message.api.js';

export default {
  name: 'EventManagementWrapper',
  components: { EventManagement },
  methods: {
    getRoles() {
      return service.fetchRol();
    },
    async getCategories() {
      return await service.fetchCategory();
    },
    getEvent(id) {
      return service.fetchEventById(id);
    },
    saveEvent(params) {
      return service.saveEvent(params);
    },
    updateEvent(params) {
      return service.updateEvent(params);
    },
    getApplications() {
      return _getApplications();
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/shared/scss/config/_colors.scss';
.event-management {
  &__extended ::v-deep {
    .custom-link.color--red {
      color: map-get($colors, 'red');
    }
    .custom-link.color--green {
      color: map-get($colors, 'green');
    }
  }
}
</style>
